import styled from "styled-components";

export const Title = styled.div`
  font-size: 2rem;
  color: white;
  font-weight: 700;
`;

export const Subtitle = styled.div`
  font-size: 1.8rem;
  color: #fff;
`;

export const Paragraph = styled.p`
  font-size: 0.9rem;
  font-weight: 400;
  color: #000;
`;
